<template>
  <publicExport :exportTypeList="exportTypeList"></publicExport>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import publicExport from "@/components/common/publicExport";
import {setConfigCharacters} from "@/utils/common";

export default {
  name: "exportTask",
  data() {
    return {
      exportTypeList: [
        {value: 'ymsMerchantPropertyLogExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003683')},
        {value: 'ymsDownloadProductExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005608')},
        {value: 'ymsPackageInfosExport', name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')}`},
        {value: 'ymsDistributorRechargeRecordExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002931')},
        {value: 'ymsPlatformOrderExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005609')},
        {value: 'YmsDistributorInventoryExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001107')},
        {value: 'ymsDistributorStockUpInfoExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005610')},
      ]
    };
  },
  components: {
    publicExport
  }
};
</script>

<style scoped>

</style>
